import { Box, Flex, useToast } from "@chakra-ui/react";
import {
  Elements,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CustomButton from "../../../components/buttons/CustomButton";
const stripePromise = loadStripe(
  "pk_test_51PdpbGFaluJelcGPBdknVaPTkyALTvcPTsLiUKuxl0JkbybRD6AdqCUjbQ35Fy9lqbTpUqfF6FVmloey9Q3yYwaW006GjJvieI"
);
function PaymentForm({ paymentIntent }: any) {
  return (
    <Box minH="421px" w="100%">
      {stripePromise && paymentIntent && (
        <Elements
          stripe={stripePromise}
          options={{
            clientSecret: paymentIntent,
          }}
        >
          <StripeForm />
        </Elements>
      )}
    </Box>
  );
}

const StripeForm = () => {
  const toast = useToast();

  const stripe = useStripe();
  const elements = useElements();

  const handlePayment = async () => {
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: window.location.href,
      },
    });
    if (error) {
      toast({
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <PaymentElement />
      <Flex mt="24px">
        <CustomButton
          btnTitle="Pay Now"
          bg="yess.secondary_gold"
          onClick={() => {
            handlePayment();
          }}
        />
      </Flex>
    </>
  );
};

export default PaymentForm;
